var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patterns"},_vm._l((3),function(i){return _c('div',{key:i,staticClass:"patterns__pattern",class:'patterns__pattern--' + i})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }